module.exports = __webpack_public_path__ + "img/Pellets-lager.3fcd275.webp";